module.exports = __webpack_public_path__ + "static/gold_dragon-3af0795a48a43cd3e3c5b7ebd8ec151c.jpg";